import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';
import { token } from '@atlaskit/tokens';

const PREVIEW_WIDTH = 140;
const PREVIEW_HEIGHT = 80;
const PREVIEW_PADDING_BLOCK = token('space.075');
const PREVIEW_PADDING_INLINE = token('space.100');

const styles = cssMap({
	preview: {
		width: `${PREVIEW_WIDTH}px`,
		minWidth: `${PREVIEW_WIDTH}px`,
		height: `${PREVIEW_HEIGHT}px`,
		borderRadius: token('radius.large'),
		overflow: 'hidden',
		backgroundColor: token('elevation.surface'),
		paddingBlock: PREVIEW_PADDING_BLOCK,
		paddingInline: PREVIEW_PADDING_INLINE,
		border: `${token('border.width')} solid ${token('color.border')}`,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
});

export type SnippetPreviewContainerProps = {
	children: React.ReactNode;
};

export const SnippetPreviewContainer = ({ children }: SnippetPreviewContainerProps) => {
	return <Box xcss={styles.preview}>{children}</Box>;
};

/** Exported for SnippetPreview dimensions calculation in SnippetPanelItem */
export const SNIPPET_PREVIEW_CONTAINER = {
	width: PREVIEW_WIDTH,
	height: PREVIEW_HEIGHT,
	paddingBlock: PREVIEW_PADDING_BLOCK,
	paddingInline: PREVIEW_PADDING_INLINE,
} as const;
